<template>
  <div>
    <div
      ref="fotoPortadaRef"
      class="fotoportada-container"
    >
      <div class="overlay">
        
        <!-- Contenedor unificado para lograr la estructura idéntica a image_9883df.png -->
        <div class="bloque-central-portada">
          
          <!-- 1. CabeceraSupeaasdasdasdsadasdasdasdsadasdasdasdasdasdsadasdsdasdsadrior -->
          <div
            ref="misXvTopRef"
            class="mis-xv-central-wrap"
          >
            
            <div class="mis-xv-top glowing">
              MIS XV
            </div>
          </div>

          <!-- 2. Nombre en dos líneas consecutivas con tipografía Serif elegante visible -->
          <h1 ref="nombreRef" class="nombre-principal-invitacion">
            <span class="linea-nombre">Valentina</span>
            <span class="linea-apellido"></span>
          </h1>

          <!-- 3. Fecha del Evento inferior alineada -->
          <div
            ref="fechaRef"
            class="fecha-evento"
          >
            <span class="fecha-dia"></span>
            <span class="fecha-separador"></span>
            <span class="fecha-mes"></span>
            <span class="fecha-separador"></span>
            <span class="fecha-anio"></span>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import gsap from 'gsap';

export default {
  name: 'NavbarComponent',
  setup() {
    const fotoPortadaRef = ref(null);
    const nombreRef = ref(null);
    const fechaRef = ref(null);
    const misXvRef = ref(null);
    const misXvTopRef = ref(null);

    onMounted(() => {
      const tl = gsap.timeline();

      // Ajustamos los estados iniciales de opacidad en lote para evitar destellos antes de tiempo
      gsap.set([misXvTopRef.value, fechaRef.value.children], { opacity: 0 });
      if (nombreRef.value) {
        gsap.set(nombreRef.value.querySelectorAll('span'), { opacity: 0 });
      }

      // 1. Entrada de la Foto de Portada (Revelado sutil subiendo)
      tl.fromTo(fotoPortadaRef.value, {
        opacity: 0,
        y: 60,
      }, {
        opacity: 1,
        y: 0,
        duration: 1.6,
        ease: 'power3.out'
      })

      // 2. Entrada de la Cabecera "MIS XV" + Corona (Emerge suavemente hacia arriba)
      .fromTo(misXvTopRef.value, {
        opacity: 0,
        y: 45,
      }, {
        opacity: 1,
        y: 0,
        duration: 1.2,
        ease: 'power4.out'
      }, '-=1.1')

      // 3. Entrada consecutiva del Nombre en dos líneas (Aparecen subiendo elegantemente)
      .fromTo(nombreRef.value.querySelectorAll('span'), {
        opacity: 0,
        y: 50,
      }, {
        opacity: 1,
        y: 0,
        duration: 1.3,
        stagger: 0.25, 
        ease: 'power4.out'
      }, '-=0.9')

      // 4. Entrada escalonada de los componentes de la fecha flotando hacia arriba
      .fromTo(fechaRef.value.children, {
        opacity: 0,
        y: 25,
      }, {
        opacity: 1,
        y: 0,
        duration: 1,
        stagger: 0.12,
        ease: 'power2.out'
      }, '-=0.7');

      // Mantenemos tu condicional de contingencia intacto
      if (misXvRef.value) {
        gsap.from(misXvRef.value, {
          opacity: 0,
          y: 40,
          scale: 0.9,
          duration: 1.3,
          ease: 'back.out(1.7)',
          delay: 2.2
        });
      }

      // --- EFECTO DE CIELO ESTRELLADO ORIGINAL ---
      const totalEstrellas = 45; 
      const container = fotoPortadaRef.value;

      if (container) {
        for (let i = 0; i < totalEstrellas; i++) {
          const estrella = document.createElement('div');
          
          if (Math.random() > 0.4) {
            estrella.className = 'star-sparkle';
          } else {
            estrella.className = 'star-dot';
          }

          const posX = Math.random() * 100;
          const posY = Math.random() * 100;
          const size = Math.random() * 12 + 6; 

          estrella.style.left = `${posX}%`;
          estrella.style.top = `${posY}%`;
          estrella.style.width = `${size}px`;
          estrella.style.height = `${size}px`;

          container.appendChild(estrella);

          gsap.fromTo(estrella, 
            { opacity: 0, scale: 0, rotation: 0 },
            {
              opacity: Math.random() * 0.7 + 0.3, 
              scale: Math.random() * 0.4 + 0.8,
              rotation: Math.random() > 0.5 ? 180 : -180, 
              duration: Math.random() * 2 + 1.5, 
              delay: Math.random() * 2, 
              repeat: -1, 
              yoyo: true, 
              ease: "sine.inOut"
            }
          );
        }
      }
    });

    return {
      fotoPortadaRef,
      nombreRef,
      fechaRef,
      misXvRef,
      misXvTopRef
    };
  }
};
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
}

.fotoportada-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  margin-top: -65px;
  background-image: 
    linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.4)), 
    url('@/assets/INVITACIONVALE-80(3).webp');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  z-index: 1;
  box-shadow: 0 -40px 80px rgba(255, 255, 255, 0.2) inset,
              0 20px 40px rgba(0, 0, 0, 0.3);
}

:deep(.star-dot) {
  position: absolute;
  background: radial-gradient(circle, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 70%);
  border-radius: 50%;
  pointer-events: none;
  z-index: 2;
}

:deep(.star-sparkle) {
  position: absolute;
  pointer-events: none;
  z-index: 2;
  background: white;
  clip-path: polygon(50% 0%, 61% 39%, 100% 50%, 61% 61%, 50% 100%, 39% 61%, 0% 50%, 39% 39%);
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.8);
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start; 
  color: white;
  z-index: 3; 
}

.bloque-central-portada {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 60px; 
  width: 100%;
  padding: 0 20px;
}

.mis-xv-central-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 520px;
  will-change: transform, opacity;
}

.ornamento-img {
  width: 42px;
  height: auto;
  opacity: 1;
  filter: brightness(0) invert(1);
  margin-bottom: 6px;
}

.mis-xv-top {
  font-family: 'file';
  font-size: 22px;
  letter-spacing: 2px;
  color: white;
}

.glowing {
  animation: glow 2.5s ease-in-out infinite alternate;
}

@keyframes glow {
  from {
    text-shadow: 0 0 5px rgba(255,255,255,0.3);
  }
  to {
    text-shadow: 0 0 15px rgba(255,255,255,0.9);
  }
}

/* --- SOLUCIÓN: Color blanco sólido y text-shadow para visibilidad perfecta --- */
.nombre-principal-invitacion {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.35;
  margin: 0 0 25px 0;
  font-family: 'british',  serif !important;
  font-size: 42px;
  font-weight: 500;
  letter-spacing: 2px;
  margin-bottom: -15px;;
  color: #ffffff !important; /* Forzado a blanco puro */
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.5); /* Sombra elegante que lo separa del fondo */
}

.nombre-principal-invitacion span {
  display: block;
  will-change: transform, opacity;
}

.fecha-evento {
  font-family: 'Karla', sans-serif;
  color: white;
  font-size: 16px;
  letter-spacing: 3px;
  text-transform: uppercase;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 5px;
}

.fecha-evento span {
  display: inline-block;
  will-change: transform, opacity;
}

.mis-xv-text {
  font-family: 'Daydream', cursive;
  font-size: 30px;
  color: #f8a4cf;
  text-align: right;
  width: 90%;
  margin-top: -10px;
  margin-bottom: -50px;
  letter-spacing: 2px;
  position: absolute;
  right: 5%;
  bottom: 60px;
  z-index: 3;
}

.separador-container {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  position: relative;
  height: 80px;
  margin-top: -15px;
  margin-bottom: 30px;
}

.separador-img2 {
  width: 100%;
  height: auto;
  z-index: 2;
}

@media (min-width: 640px) {
  .nombre-principal-invitacion {
    font-size: 56px;
    line-height: 1.15;
  }
  .bloque-central-portada {
    margin-top: 80px;
  }
  .fecha-evento {
    font-size: 19px;
  }
}
</style>